import moment from "moment";

const primeiroDiaMesAtual = moment()
  .startOf("month")
  .format("YYYY-MM-DD");
const ultimoDiaMesAtual = moment()
  .endOf("month")
  .format("YYYY-MM-DD");


export const StatusEnum ={
  PENDENTE_APROVACAO : "Pendente",
  APROVADO :"Aprovado",
  REPROVADO : "Reprovado",
  FINALIZADO : "Finalizado",
  EM_ANDAMENTO : "Em andamento",
  CANCELAR_EXECUCAO : "Cancelado",
}

export const columns = [
  {
    Header: "Data/Hora",
    align: "left",
    getValue: (data) => {
      return data.dataHoraLancamento ? moment(data.dataHoraLancamento).format("DD/MM/YYYY HH:mm") : "-";
    },
    field: "dataHoraLancamento",
  },
  {
    Header: "Status",
    align: "left",
    getValue: (data) => {
      return StatusEnum[data.status];
    },
    field: "status",
  },
  {
    Header: "Paciente",
    align: "left",
    getValue: (data) => {
      return data.pacienteNome || "-";
    },
    field: "pacienteNome",
  },
  {
    Header: "Executante",
    align: "left",
    getValue: (data) => {
      return data.profissionalExecutanteNome || "-";
    },
    field: "profissionalExecutanteNome",
  },
  {
    Header: "Procedimento",
    align: "left",
    getValue: (data) => {
      return data.procedimentoNome || "-";
    },
    field: "procedimentoNome",
  },
  {
    Header: "Realizado por",
    align: "left",
    getValue: (data) => {
      return data.profissionalExecucao || "-";
    },
    field: "profissionalExecucao",
  },
  {
    Header: "Data realização",
    align: "left",
    getValue: (data) => {
      return data.dataExecucao ? moment(data.dataExecucao).format("DD/MM/YYYY HH:mm") : "-";
    },
    field: "dataExecucao",
  },
];

export const filtersDefault = {
  dataInicio: primeiroDiaMesAtual,
  dataFim: ultimoDiaMesAtual,
  paciente: null,
  profissionalAtendimento: null,
  tipoAcao: "TODOS",
};

export const pageableDTODefault = {
  pageNumber: 0,
  pageSize: 30,
  sortField: "dataHoraLancamento",
  sortDir: "DESC",
};

export const tipoAcaoOptions = [
  { label: "Todos", value: "TODOS" },
  { label: "Apenas Realizados", value: "REALIZADOS" },
  { label: "Apenas Finalizados", value: "FINALIZADOS" },
];
